import React, { createContext, useContext, useState } from 'react';

const GuardianLanguageContext = createContext(null);

function defaultLang() {
  return localStorage.getItem('jahbath_guardian_lang') || 'ar';
}

export function GuardianLanguageProvider({ children }) {
  const [lang, setLangState] = useState(defaultLang);

  const setLang = (l) => {
    localStorage.setItem('jahbath_guardian_lang', l);
    setLangState(l);
  };

  return (
    <GuardianLanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </GuardianLanguageContext.Provider>
  );
}

export function useGuardianLanguage() {
  return useContext(GuardianLanguageContext);
}
